import { ButtonHTMLAttributes, FC } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import cn from 'utils/cn';

export type TControlBarSubButton = {
  label: string | React.ReactNode;
  isOpen: boolean;
  handleToggle: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  containerBorders: {
    left: boolean;
    right: boolean;
  };
  buttonProps?: ButtonHTMLAttributes<HTMLButtonElement>;
};

const ControlBarSubButton: FC<TControlBarSubButton> = ({
  label,
  isOpen,
  handleToggle,
  containerBorders,
  buttonProps,
}) => {
  return (
    <button
      data-testid="control-bar-sub-button"
      className={cn(
        'tw:cursor-pointer tw:border-t-0 tw:border-b-0 tw:px-3 tw:h-10 tw:flex',
        containerBorders.left ? 'tw:border-l' : 'tw:border-l-0',
        containerBorders.right ? 'tw:border-r' : 'tw:border-r-0',
        isOpen
          ? 'tw:bg-accent-100 tw:text-primary-100 tw:border-0'
          : 'tw:bg-primary-200 tw:border-primary-300 tw:hover:bg-primary-100 tw:text-secondary-400'
      )}
      style={{
        zIndex: isOpen ? 1202 : 'unset',
        boxShadow: isOpen ? '-4px 0px 4px 0px #00000040' : 'none',
      }}
      type="button"
      onClick={handleToggle}
      {...buttonProps}
    >
      <span
        className={
          'tw:h-[inherit] tw:font-light tw:text-sm tw:leading-4 tw:pr-1 tw:flex tw:items-center tw:justify-center'
        }
      >
        {label}
      </span>

      <span
        className={`tw:h-[inherit] tw:font-light tw:text-sm tw:leading-4 tw:pr-1 tw:flex tw:items-center tw:justify-center ${
          isOpen ? 'tw:text-primary-100' : 'tw:text-primary-600'
        }`}
      >
        {!isOpen ? <ExpandMore fontSize="inherit" /> : <ExpandLess fontSize="inherit" />}
      </span>
    </button>
  );
};

export default ControlBarSubButton;
